var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import config from "@/config";
var CoreProgressBar = /** @class */ (function (_super) {
    __extends(CoreProgressBar, _super);
    function CoreProgressBar(scene, width, height, fontSize) {
        var _this = _super.call(this, scene) || this;
        _this._w = width;
        _this._h = height;
        _this.box = new Phaser.GameObjects.Graphics(scene);
        _this.bar = new Phaser.GameObjects.Graphics(scene);
        _this.box.fillStyle(0x1a1a20, 0.8);
        _this.box.fillRect(0, 0, _this._w, _this._h);
        _this.text = new Phaser.GameObjects.Text(scene, width / 2, height / 2, "0%", {
            align: "center",
            color: "#ffffff",
            fontFamily: config.graphics.fontFamily,
        })
            .setOrigin(0.5)
            .setFontSize(fontSize);
        _this.add(_this.box);
        _this.add(_this.bar);
        _this.add(_this.text);
        return _this;
    }
    CoreProgressBar.prototype.setValue = function (value) {
        this.text.setText("".concat(value, "%"));
        this.bar.clear();
        this.bar.fillStyle(0x00aaff, 1);
        this.bar.fillRect(10, 10, (value * (this._w - 2 * 10)) / 100, this._h - 2 * 10);
    };
    return CoreProgressBar;
}(Phaser.GameObjects.Container));
export default CoreProgressBar;
